/**
 * @module FE-CU12_警報確認画面
 */
import Header from '../../../components/header/Header.vue';
import ListPanel from '../../../components/listPanel/ListPanel.vue';
import MobileFooter from '../../../components/footer/MobileFooter.vue';
import BreadCrumbList from '../../../components/breadCrumb/List.vue';
import PcPageTitle from '../../../components/pcPageTitle/PcPageTitle.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import CONSTANTS from '../../../constants';

const PAGE_ID = 'FE-CU12';

export default {
  name: 'AlertConfirm',
  components: {
    Header,
    ListPanel,
    MobileFooter,
    BreadCrumbList,
    PcPageTitle,
    PCFooter,
  },
  data(vm) {
    return {
      displayName: vm.$vuetify.lang.t('$vuetify.FECU12警報確認画面.警報確認'),
      panelTitle: {
        place: '',
        type: '$vuetify.FECU12警報確認画面.対象地区詳細.対象地区',
        typeIsBefore: true,
      },
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU12警報確認画面.C0001'),
      displayAreaList: [],
      title: vm.$vuetify.lang.t('$vuetify.FECU12警報確認画面.警報確認'),
      firstRow: [
        {
          id: 1,
          label: vm.$vuetify.lang.t('$vuetify.FECU12警報確認画面.侵入'),
          url: '/areaLockConfirmation',
          img: 'icon_invasion.svg',
          from: 1,
          alert: false,
          disabled: false,
        },
        {
          id: 2,
          label: vm.$vuetify.lang.t('$vuetify.FECU12警報確認画面.非常'),
          url: '/sensorWarningConfirmation',
          img: 'icon_emergency.svg',
          from: 2,
          alert: false,
          disabled: false,
        },
        {
          id: 3,
          label: vm.$vuetify.lang.t('$vuetify.FECU12警報確認画面.火災'),
          url: '/sensorWarningConfirmation',
          img: 'icon_fire.svg',
          from: 3,
          alert: false,
          disabled: false,
        },
        {
          id: 4,
          label: vm.$vuetify.lang.t('$vuetify.FECU12警報確認画面.ガス'),
          url: '/sensorWarningConfirmation',
          img: 'icon_gas.svg',
          from: 4,
          alert: false,
          disabled: false,
        },
      ],
      secondRow: [
        {
          id: 1,
          label: vm.$vuetify.lang.t('$vuetify.FECU12警報確認画面.ライフリズム'),
          url: '/sensorWarningConfirmation',
          img: 'icon_lifeRhythm.svg',
          from: 5,
          alert: false,
          disabled: false,
        },
        {
          id: 2,
          label: vm.$vuetify.lang.t('$vuetify.FECU12警報確認画面.電池'),
          url: '/sensorWarningConfirmation',
          img: 'icon_battery.svg',
          from: 6,
          alert: false,
          disabled: false,
        },
        {
          id: 3,
          label: vm.$vuetify.lang.t('$vuetify.FECU12警報確認画面.機器異常'),
          url: '/sensorWarningConfirmation',
          img: 'icon_equipmentAlert.svg',
          from: 7,
          alert: false,
          disabled: false,
        },
        {
          id: 4,
          label: vm.$vuetify.lang.t('$vuetify.FECU12警報確認画面.設備'),
          url: '/sensorWarningConfirmation',
          img: 'icon_facility.svg',
          from: 8,
          alert: false,
          disabled: false,
        },
      ],
      CONSTANTS: CONSTANTS,
      width: 0,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        displayName: vm.$vuetify.lang.t('$vuetify.FECU12警報確認画面.警報確認'),
        title: vm.$vuetify.lang.t('$vuetify.FECU12警報確認画面.警報確認'),
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU12警報確認画面.C0001'),
        firstRow: [
          {
            id: 1,
            label: vm.$vuetify.lang.t('$vuetify.FECU12警報確認画面.侵入'),
            url: '/areaLockConfirmation',
            img: this.getIconName(
              'icon_invasion',
              this.firstRow[0].disabled,
              this.firstRow[0].alert
            ),
            from: 1,
            alert: this.firstRow[0].alert,
            disabled: this.firstRow[0].disabled,
          },
          {
            id: 2,
            label: vm.$vuetify.lang.t('$vuetify.FECU12警報確認画面.非常'),
            url: '/sensorWarningConfirmation',
            img: this.getIconName(
              'icon_emergency',
              this.firstRow[1].disabled,
              this.firstRow[1].alert
            ),
            from: 2,
            alert: this.firstRow[1].alert,
            disabled: this.firstRow[1].disabled,
          },
          {
            id: 3,
            label: vm.$vuetify.lang.t('$vuetify.FECU12警報確認画面.火災'),
            url: '/sensorWarningConfirmation',
            img: this.getIconName('icon_fire', this.firstRow[2].disabled, this.firstRow[2].alert),
            from: 3,
            alert: this.firstRow[2].alert,
            disabled: this.firstRow[2].disabled,
          },
          {
            id: 4,
            label: vm.$vuetify.lang.t('$vuetify.FECU12警報確認画面.ガス'),
            url: '/sensorWarningConfirmation',
            img: this.getIconName('icon_gas', this.firstRow[3].disabled, this.firstRow[3].alert),
            from: 4,
            alert: this.firstRow[3].alert,
            disabled: this.firstRow[3].disabled,
          },
        ],
        secondRow: [
          {
            id: 1,
            label: vm.$vuetify.lang.t('$vuetify.FECU12警報確認画面.ライフリズム'),
            url: '/sensorWarningConfirmation',
            img: this.getIconName(
              'icon_lifeRhythm',
              this.secondRow[0].disabled,
              this.secondRow[0].alert
            ),
            from: 5,
            alert: this.secondRow[0].alert,
            disabled: this.secondRow[0].disabled,
          },
          {
            id: 2,
            label: vm.$vuetify.lang.t('$vuetify.FECU12警報確認画面.電池'),
            url: '/sensorWarningConfirmation',
            img: this.getIconName(
              'icon_battery',
              this.secondRow[1].disabled,
              this.secondRow[1].alert
            ),
            from: 6,
            alert: this.secondRow[1].alert,
            disabled: this.secondRow[1].disabled,
          },
          {
            id: 3,
            label: vm.$vuetify.lang.t('$vuetify.FECU12警報確認画面.機器異常'),
            url: '/sensorWarningConfirmation',
            img: this.getIconName(
              'icon_equipmentAlert',
              this.secondRow[2].disabled,
              this.secondRow[2].alert
            ),
            from: 7,
            alert: this.secondRow[2].alert,
            disabled: this.secondRow[2].disabled,
          },
          {
            id: 4,
            label: vm.$vuetify.lang.t('$vuetify.FECU12警報確認画面.設備'),
            url: '/sensorWarningConfirmation',
            img: this.getIconName(
              'icon_facility',
              this.secondRow[3].disabled,
              this.secondRow[3].alert
            ),
            from: 8,
            alert: this.secondRow[3].alert,
            disabled: this.secondRow[3].disabled,
          },
        ],
      };
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 警報ボタン押下処理
     * @param {*} url 遷移先URL
     * @param {*} from 警報種別
     */
    push(url, from) {
      if (from == 1) this.$store.commit('setGettingInFlag', { gettingInFlag: true });
      this.$store.state.displayType = from;
      this.$router.push({ path: url });
    },
    /**
     * 警報データ取得(APP_CU1201)
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns レスポンス
     */
    APP_CU1201: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfo: {
            //       usagePlan: 1,
            //       customerNumber: "51-1234567",
            //       securityDestinationName: "警備先1",
            //       districtSplitNumber: "0001",
            //       districtSplitName: "地区名1",
            //       displayDistrictNickname: "自宅",
            //     },
            //     warningStatusInfo: {
            //       intrusionInfoStatus: 1,
            //     },
            //     sendCustomerNumber: "sendCustomerNumber",
            //     sendCommandKey: "sendCommandKey",
            //   },
            // };
            const planTitles = {
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.オンライン監視プラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
                '$vuetify.コード.利用プランID.依頼かけつけプラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE]:
                '$vuetify.コード.利用プランID.依頼かけつけプラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.セルフ監視プラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE]:
                '$vuetify.コード.利用プランID.セルフ監視プラン',
            };

            // ListPanel格納
            this.displayAreaList = [];
            this.panelTitle = {
              place: `- ${apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname} `,
              type: '$vuetify.FECU12警報確認画面.対象地区詳細.対象地区',
              typeIsBefore: true,
            };
            this.displayAreaList.push({
              title: '$vuetify.FECU12警報確認画面.対象地区詳細.利用プラン',
              text: planTitles[apiData.contentsInfo.displayDistrictInfo.usagePlan],
            });
            this.displayAreaList.push({
              title: '$vuetify.FECU12警報確認画面.対象地区詳細.お客様番号',
              text: apiData.contentsInfo.displayDistrictInfo.customerNumber,
            });
            this.displayAreaList.push({
              title: '$vuetify.FECU12警報確認画面.対象地区詳細.警備先名',
              text: apiData.contentsInfo.displayDistrictInfo.securityDestinationName,
            });
            this.displayAreaList.push({
              title: '$vuetify.FECU12警報確認画面.対象地区詳細.地区番号',
              text:
                apiData.contentsInfo.displayDistrictInfo.districtSplitNumber === '    '
                  ? '$vuetify.FECU12警報確認画面.対象地区詳細.メイン地区'
                  : apiData.contentsInfo.displayDistrictInfo.districtSplitNumber,
            });
            this.displayAreaList.push({
              title: '$vuetify.FECU12警報確認画面.対象地区詳細.地区名',
              text: apiData.contentsInfo.displayDistrictInfo.districtSplitName,
            });

            this.firstRow.forEach(function (row) {
              row.alert = false;
              row.disabled = false;
            });
            this.secondRow.forEach(function (row) {
              row.alert = false;
              row.disabled = false;
            });
            if (apiData.contentsInfo.warningStatusInfo.intrusionInfoStatus == 1) {
              this.firstRow[0].alert = true;
            } else if (apiData.contentsInfo.warningStatusInfo.intrusionInfoStatus == 2) {
              this.firstRow[0].disabled = true;
            }
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * 警備ユニットコマンド実行結果確認(APP_CO9915)
     * @param {*} params リクエストのパラメータ
     * @returns レスポンス
     */
    APP_CO9915: async function (params) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response) => {
          apiData = response;
          // サンプルデータ
          // apiData = {
          //   contentsInfo: {
          //     securityUnitExecutionResult: 0,
          //     commandExecutionResult: {
          //       app_cu1201: {
          //         warningStatusInfo: {
          //           emergencyInfo: {
          //             alarmUnitStatus: 2,
          //           },
          //           fireInfo: {
          //             alarmUnitStatus: 1,
          //           },
          //           gasInfo: {
          //             alarmUnitStatus: 0,
          //           },
          //           lifeRhythmInfo: {
          //             alarmUnitStatus: 2,
          //           },
          //           batteryInfo: {
          //             alarmUnitStatus: 0,
          //           },
          //           equipmentAbnormalInfo: {
          //             alarmUnitStatus: 0,
          //           },
          //           facilityInfo: {
          //             alarmUnitStatus: 0,
          //           },
          //         },
          //       },
          //     },
          //   },
          // };
          if (apiData.contentsInfo.securityUnitExecutionResult == 0) {
            // 非常情報
            if (
              apiData.contentsInfo.commandExecutionResult.app_cu1201.warningStatusInfo.emergencyInfo
                .alarmUnitStatus == 1
            ) {
              this.firstRow[1].alert = true;
            } else if (
              apiData.contentsInfo.commandExecutionResult.app_cu1201.warningStatusInfo.emergencyInfo
                .alarmUnitStatus == 2
            ) {
              this.firstRow[1].disabled = true;
            }
            // 火災情報
            if (
              apiData.contentsInfo.commandExecutionResult.app_cu1201.warningStatusInfo.fireInfo
                .alarmUnitStatus == 1
            ) {
              this.firstRow[2].alert = true;
            } else if (
              apiData.contentsInfo.commandExecutionResult.app_cu1201.warningStatusInfo.fireInfo
                .alarmUnitStatus == 2
            ) {
              this.firstRow[2].disabled = true;
            }
            // ガス情報
            if (
              apiData.contentsInfo.commandExecutionResult.app_cu1201.warningStatusInfo.gasInfo
                .alarmUnitStatus == 1
            ) {
              this.firstRow[3].alert = true;
            } else if (
              apiData.contentsInfo.commandExecutionResult.app_cu1201.warningStatusInfo.gasInfo
                .alarmUnitStatus == 2
            ) {
              this.firstRow[3].disabled = true;
            }
            // ライフリズム情報
            if (
              apiData.contentsInfo.commandExecutionResult.app_cu1201.warningStatusInfo
                .lifeRhythmInfo.alarmUnitStatus == 1
            ) {
              this.secondRow[0].alert = true;
            } else if (
              apiData.contentsInfo.commandExecutionResult.app_cu1201.warningStatusInfo
                .lifeRhythmInfo.alarmUnitStatus == 2
            ) {
              this.secondRow[0].disabled = true;
            }
            // 電池情報
            if (
              apiData.contentsInfo.commandExecutionResult.app_cu1201.warningStatusInfo.batteryInfo
                .alarmUnitStatus == 1
            ) {
              this.secondRow[1].alert = true;
            } else if (
              apiData.contentsInfo.commandExecutionResult.app_cu1201.warningStatusInfo.batteryInfo
                .alarmUnitStatus == 2
            ) {
              this.secondRow[1].disabled = true;
            }
            // 機器異常情報
            if (
              apiData.contentsInfo.commandExecutionResult.app_cu1201.warningStatusInfo
                .equipmentAbnormalInfo.alarmUnitStatus == 1
            ) {
              this.secondRow[2].alert = true;
            } else if (
              apiData.contentsInfo.commandExecutionResult.app_cu1201.warningStatusInfo
                .equipmentAbnormalInfo.alarmUnitStatus == 2
            ) {
              this.secondRow[2].disabled = true;
            }
            // 設備情報
            if (
              apiData.contentsInfo.commandExecutionResult.app_cu1201.warningStatusInfo.facilityInfo
                .alarmUnitStatus == 1
            ) {
              this.secondRow[3].alert = true;
            } else if (
              apiData.contentsInfo.commandExecutionResult.app_cu1201.warningStatusInfo.facilityInfo
                .alarmUnitStatus == 2
            ) {
              this.secondRow[3].disabled = true;
            }
          } else {
            // エラーダイアログを表示する。
            // ※警備ユニットは非活性にして、グレー背景でボタンを表示する。
            this.$_securityUnitExecutionResultDialog(
              apiData.contentsInfo.securityUnitExecutionResult
            );
            this.firstRow.forEach(function (row) {
              row.disabled = true;
            });
            this.secondRow.forEach(function (row) {
              row.disabled = true;
            });
          }
        })
        .finally(() => {
          // ブラウザバック時に遷移先で Loading が途切れるのを回避
          if (this.$route.name === this.$options.name) {
            this.$_setLoading(false);
          }
        });

      return apiData;
    },
    /**
     * アイコン名取得処理
     * @param {*} prefix URLパラメータ
     * @param {*} disabled リクエストのパラメータ
     * @param {*} alert リクエストメソッド
     * @returns アイコン名
     */
    getIconName: function (prefix, disabled, alert) {
      if (disabled) {
        return prefix + '_disabled.svg';
      }
      if (alert) {
        return prefix + '_alert.svg';
      }
      return prefix + '.svg';
    },
    /**
     * 横幅変更処理
     * @param {*} width 横幅
     */
    changeItemLabelWidth(width) {
      this.width = width;
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    this.$_pvCount(PAGE_ID);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    //以降は、ローディングマークを出して警備ユニットとの通信なので、ここで画面表示
    this.isShowPage = true;

    let param = '/api/alermConfirmation/init';
    // let param = "post";

    let queries = {
      token: sessionStorage.getItem('token'),
      terminalInfo: localStorage.getItem('terminalInfo')
        ? localStorage.getItem('terminalInfo')
        : '',
      customerNumber: this.$store.state.customerNumber,
      districtSplitNumber: this.$store.state.districtSplitNumber,
    };
    let method = 'post';
    let apiData = await this.APP_CU1201(param, queries, method);

    if (typeof apiData.contentsInfo !== 'undefined') {
      let params = {
        token: queries.token,
        terminalInfo: queries.terminalInfo,
        sendCustomerNumber: apiData.contentsInfo.sendCustomerNumber,
        sendCommandKey: apiData.contentsInfo.sendCommandKey,
        apiId: 5,
        alarmType: 0,
        districtSplitNumber: '',
        securityAreaId: '',
      };
      await this.APP_CO9915(params);
    }
  },
};
